<template>
  <div id="club">
    <div id="">
      <Header
        v-if="user.admin"
        :page="'club'"
        :title_one="'club'"
        :action_one="event.main_actions ? 'edit' : ''"
      ></Header>
      <Header v-else :page="'club'" :title_one="'club'"></Header>

      <div class="full">
        <div class="row club-name mobile">
          <span class="club-title">{{ club.name }}</span>
        </div>

        <div class="row club-info">
          <div
            class="shield"
            :style="{ backgroundImage: 'url(' + club.shield + ')' }"
          ></div>
          <div class="info">
            <div class="item">
              <div class="label">{{ $t("params.club_name") }}:</div>
              <div class="value">{{ club.name }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.abbreviation") }}:</div>
              <div class="value">{{ club.abbreviation }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.web") }}:</div>
              <div class="value">{{ club.web }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.phone") }}:</div>
              <div class="value">{{ club.phone }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.phone2") }}:</div>
              <div class="value">{{ club.mobile }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.mail") }}:</div>
              <div class="value">{{ club.mail }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.address") }}:</div>
              <div class="value">{{ club.address }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.city") }}:</div>
              <div class="value">{{ club.city }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.state") }}:</div>
              <div class="value">{{ club.state }}</div>
            </div>
          </div>
        </div>

        <template v-if="club.mic_gestor && club.mic_gestor.id">
          <div class="row club-info">
            <span class="title">{{ $t("titles.mic_gestor") }}</span>

            <div class="info">
              <div class="item">
                <div class="label">{{ $t("params.name") }}:</div>
                <div class="value">{{ club.mic_gestor.name }}</div>
              </div>

              <div class="item" v-if="!integra">
                <div class="label">{{ $t("params.email") }}:</div>
                <div class="value">
                  {{ club.mic_gestor.email ? club.mic_gestor.email : "-" }}
                </div>
              </div>
              <div class="item" v-else>
                <div class="label">{{ $t("params.email") }}:</div>
                <div class="value">info@micsports.es</div>
              </div>

              <div class="item" v-if="!integra">
                <div class="label">{{ $t("params.phone") }}:</div>
                <div class="value">
                  {{ club.mic_gestor.phone ? club.mic_gestor.phone : "-" }}
                </div>
              </div>

              <div class="item"></div>
            </div>
          </div>
        </template>

        <div class="row club-info" v-if="current_event_type_id == '15'">
          <span class="title">{{ $t("titles.tax_info") }}</span>
          <div class="info">
            <div class="item">
              <div class="label">{{ $t("params.tax_id") }}:</div>
              <div class="value">{{ club.tax_id }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.tax_name") }}:</div>
              <div class="value">{{ club.tax_name }}</div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.tax_address") }}:</div>
              <div class="value">{{ club.tax_address }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/layout/Header'

export default {
  name: 'Club',

  components: {
    Header
  },

  data () {
    return {
      club: {},
      uniforms: {},
      dialog: false, // open dialog 1 (delete uniform)
      dialog2: false, // open dialog 2 (add/delete uniform)
      uniform_to_delete: 0, // id uniform to delete
      uniform: {
        // copy from uniform to edit or add
        primary_color: '',
        secondary_color: '',
        type: '',
        pants_color: '',
        socks_color: ''
      },
      error: {
        uniform: {
          primary_color: false,
          secondary_color: false,
          type: false,
          pants_color: false,
          socks_color: false
        }
      },
      type: 1, // 1 = add, 2 = edit
      integra: false,
      current_event_type_id: null
    }
  },

  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },

  created () {
    this.load()
  },

  methods: {
    load () {
      // this.current_event_type_id = this.$store.getters['event/getCurrentEvent']().type_id
      this.current_event_type_id = this.$store.getters["getCurrentEvent"]().type_id;
      // check if user isn't admin
      var self = this

      if (this.user.admin) {
        this.$store
          .dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function () {
            self.club = self.$store.getters['club/getClub']
            for (var key in self.club.teams) {
              if (self.club.teams[key].category.name === 'INTEGRA') {
                self.integra = true
              }
            }
          })
      } else {
        this.$store
          .dispatch('team/loadTeam', { team_id: this.user.team_id })
          .then(function () {
            if (self.$store.getters['team/getTeam']) {
              self.club = self.$store.getters['team/getTeam'].club
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
#club {
  .mobile {
    display: none;
  }

  .row {
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    height: auto;

    .item {
      padding: 2px;
    }

    .title {
      display: block;
      width: 100%;
    }

    .label,
    .value {
      display: inline-block;
    }
    .label {
      font-weight: bold;
      width: 150px;
    }

    .list-title {
      @include background(
        $image: img("right-arrow.svg"),
        $size: 12px,
        $position: right 6px center
      );
      height: 40px;
      width: 100%;
      display: block;
      padding: 0 20px;
      font-size: 24px;
      line-height: 40px;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: $main-color-t30;
    display: block;
    width: 100%;
    margin: 6px;
  }

  .club-name {
    background: none;
    width: 100%;
    overflow: hidden;

    .club-title {
      @include text-ellipsis();
      display: block;
      font-size: 26px;
      font-weight: bold;
      color: $main-color;
      text-align: center;
      width: 100%;
    }
  }

  .club-info {
    // @include display-flex();
    @include align-items(center);
    background-color: #f5f5f5;
    padding: 12px;

    .shield,
    .info {
      float: left;
    }
    .shield {
      @include background($size: cover);
      width: 250px;
      height: 250px;
      border: none;
      border-radius: 3px;
      margin: 0 auto;
    }
    .info {
      width: calc(100% - 250px);
      padding-left: 12px;
    }

    .label {
      @include text-ellipsis();
      text-align: right;
      margin-right: 6px;
      font-size: 16px;
      font-family: AvantGarde-Bold;
    }
    .value {
      @include text-ellipsis();
      font-size: 16px;
    }
  }

  @include media("<=desktop") {
    #content {
      padding: 12px !important;

      .club-info {
        height: auto;
        overflow: hidden;

        .shield {
          float: none;
          width: 100%;
        }
        .info {
          width: 100%;
          float: none;
        }
      }
    }
  }

  @include media(">phone", "<tablet") {
    .mobile {
      display: block;
    }

    .title-team {
      display: none;
    }

    .club-info {
      @include flex-wrap(wrap);
      @include align-items();

      .shield {
        margin-bottom: 12px;
        width: 100%;
        background-size: contain;
      }
      .info {
        width: 100%;

        .item {
          max-width: 100%;
          max-width: 100px;

          .label {
            width: auto;
          }
          .value {
            width: auto;
          }
        }
      }
    }
  }
}

@include media(">phone", "<tablet") {
  .v-dialog.v-dialog--active {
    overflow: auto;
  }
}
</style>
